<template>
	<div id="about">
		<div>关于我们</div>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
			};
		},
		methods: {
			onClick(){
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/about/index.vue